<template>
    <v-row class="mx-12">
        <v-col class="" cols="12">
            <v-card class="green lighten-4 pa-6 mx-auto elevation-12">
                <v-card-title class="justify-center">
                    <v-layout align-center>
                        <v-flex>
                            <div class="teal--text display-2 font-weight-bold text-center">절차가 복잡할거 같다구요? 걱정 NO!</div>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-row>
                    <v-col v-for="(step, index) in steps" xl="4" md="6" sm="12">
                        <v-card class="elevation-6">
                            <div class="d-flex">
                                <div>
                                    <v-avatar class="ma-3" size="125" tile>
                                        <v-img :src="step.src"></v-img>
                                    </v-avatar>
                                </div>
                                <div>
                                    <v-card-title class="headline"><b class="teal--text">{{index+1}}.</b> {{step.title}}</v-card-title>
                                    <v-card-subtitle>{{step.subtitle}}</v-card-subtitle>
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
                <p class="mb-0">* CMC(Car Management Counsultant) 차량관리 전문 노하우를 바탕으로 고객님의 편안한 자동차 생활을 제안하기 위한 VIP리모렌터카의 자동차 컨설턴트를 말합니다. 언제 어디서든 효율적인 자동차 생활을 제안합니다.</p>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
export default {
    name: "NewcarSteps",
    components: {
    },
    data: () => ({
        steps: [
            {
                title: '견적신청',
                subtitle: 'VIP리모렌터카 고객센터 (02) 3141 - 2345 또는 홈페이지 내에 있는 메일 문의를 신청해주세요.',
                src: require('../../assets/newcar/icon1.png')
            },
            {
                title: '1:1 고객 맞춤 상담',
                subtitle: 'VIP리모렌터카의 준비된 전문 직원인 CMC*(차량관리컨설던트)와 개별 상담을 진행합니다.',
                src: require('../../assets/newcar/icon2.png')
            },
            {
                title: '계약 완료',
                subtitle: 'CMC와 상담이 끝나신 후, 렌트에 필요한 기본 서류 제출해주시고 계약서를 작성합니다.',
                src: require('../../assets/newcar/icon3.png')
            },
            {
                title: '차량 인도',
                subtitle: '계약 시 신차를 선택하신 경우, 출고 제공 인도시점까지 필요 시 대차를 제공해드립니다. (유료)',
                src: require('../../assets/newcar/icon4.png')
            },
            {
                title: '차량 관리 서비스',
                subtitle: 'VIP리모렌터카가 만든 차량관리 서비스의 정기적인 차량관리 서비스를 제공해드립니다. (상품에 따라 제공서비스 차이 있음)',
                src: require('../../assets/newcar/icon5.png')
            },
            {
                title: '재계약 또는 반납',
                subtitle: '렌트 기간이 끝나면 재계약을 하시거나 원치 않으실 경우 반납해 주시면 인수해드립니다.',
                src: require('../../assets/newcar/icon6.png')
            }
        ]
    })
};
</script>
<style scoped></style>
